import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Edit, Visibility } from "@material-ui/icons";
import { navigate } from "@gatsbyjs/reach-router";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";
import { JobApprovalStatus } from "Pages/Job/components/JobApprovalStatus";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonRight: {
            marginLeft: "auto"
        }
    })
);

interface IProps {
    fieldData: Compleo.IObject;
    hideViewIcon?: boolean;
}

const OtherActions = (props: IProps) => {
    const { fieldData, hideViewIcon = false } = props;
    const classes = useStyles();
    const jobStatus: CompleoShared.Common.JobStatus = fieldData.status;
    const jobApprovalStatus: CompleoShared.Common.JobStatus[] = [
        "jobApprovalApproved",
        "jobApprovalRejected",
        "jobApprovalInProgress",
        "jobApprovalRequested",
        "jobApprovalAwaitingCorrection",
        "jobApprovalExpired"
    ];
    const showJobApprovalIcon = jobApprovalStatus.includes(jobStatus);
    const jobId = fieldData.pk.split(":")[1];

    const editJob = () => {
        navigate(`/job/editrequest/${jobId}`);
    };

    const viewJob = () => {
        navigate(`/job/viewrequest/${jobId}`);
    };
    const status: CompleoShared.Common.JobStatus = fieldData.status;
    const showEditButton =
        status === "requested" ||
        status === "awaitingCorrectionRequest" ||
        status === "jobApprovalRejected";

    return (
        <>
            <span className={classes.buttonRight} />
            {showJobApprovalIcon && (
                <JobApprovalStatus jobId={jobId} jobTitle={fieldData.title} />
            )}
            {!hideViewIcon && (
                <ButtonIconTooltipCompleo label="View" onClick={viewJob}>
                    <Visibility />
                </ButtonIconTooltipCompleo>
            )}
            {showEditButton && (
                <ButtonIconTooltipCompleo label="Edit" onClick={editJob}>
                    <Edit />
                </ButtonIconTooltipCompleo>
            )}
        </>
    );
};

export default OtherActions;
